import { NavLink } from "react-router-dom";
import '@milestone-sys/web-design-system/main.css';
import './AppFooter.scss';
import maketheworldsee from './maketheworldsee.svg';

function AppFooter() {
    
    const currentYear = new Date().getFullYear();

    return (        
        <div className="container-fluid app-footer mt-auto">
            <div className="row">
                <div className="col-12 app-footer__body px-4 py-8">
                    <img src={maketheworldsee} className="mb-6" />                    
                    <div className="app-footer__content-wrapper">                    
                        <NavLink className="app-footer__content msds-link--secondary" to="/cookie-policy">Cookie Policy</NavLink>
                        <div className="app-footer__content">Copyright © {currentYear} Milestone systems A/S. All rights reserved.</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppFooter;